import { BASE_URL, DO_NOT_ORDER_LIST_ENDPOINT, SOMS_API_KEY } from "services/CONSTANTS";
import { SEARCH_DNO_FAILURE, SEARCH_DNO_REQUEST, SEARCH_DNO_RESET, SEARCH_DNO_SUCCESS } from "./action-type"
import { Get } from "services/apiService";

export const searchDoNotOrderListAction = (payload,feature) => {
    return (dispatch) => {
        dispatch(searchDoNotOrderListRequest());
        const apiUrl = `${BASE_URL}${DO_NOT_ORDER_LIST_ENDPOINT}?apikey=${SOMS_API_KEY}&feature=${feature}`;
        
        Get({
            url: apiUrl,
            params: payload
        })
            .then((response) => {
                if (response.status === 200) {
                    dispatch(searchDoNotOrderListSuccess(response));
                } else {
                    dispatch(searchDoNotOrderListFailure(response));
                }
            })
            .catch((err) => {
                dispatch(searchDoNotOrderListFailure(err));
            });
    }
}

const searchDoNotOrderListRequest = () => {    
    return {
        type: SEARCH_DNO_REQUEST
    }
}

const searchDoNotOrderListSuccess = (response) => {
    return {
        type: SEARCH_DNO_SUCCESS,
        searchDNOResponse: response
    }
}

const searchDoNotOrderListFailure = (error) => {
    return {
        type: SEARCH_DNO_FAILURE,
        searchDNOResponse: error
    }
}

export const searchDoNotOrderListReset = () => {
    return {
        type: SEARCH_DNO_RESET
    }
}